import { render, staticRenderFns } from "./jin-lian-private.vue?vue&type=template&id=022761b3&scoped=true"
import script from "./jin-lian-private.vue?vue&type=script&lang=js"
export * from "./jin-lian-private.vue?vue&type=script&lang=js"
import style0 from "./jin-lian-private.vue?vue&type=style&index=0&id=022761b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022761b3",
  null
  
)

export default component.exports